export default __webpack_public_path__ + "static/media/person.af6eccf9.png";